import React, { useRef } from 'react';
import '../../Styles/Teams.scss';
import teamicon from '../../Assests/Product/empowerPNG.png';
import RoleofDashboard from '../Team/RoleofDashboard';
import ProdWhyGoPremium from './ProdWhyGoPremium';

function Product() {

    const teamSectionRef = useRef(null);

    const scrollToSection = () => {
        if (teamSectionRef.current) {
            teamSectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <>
            <div style={{ backgroundColor: '#F1F1F1' }}>
                <div className='row team-discover-story-teams  w-100  ' >
                    <div className='col-md-6  ms-5 me-5 '>

                        <div className=' empower-text overall-text-color' style={{ fontSize: '78px', fontWeight: '700' }}>
                            <div >Empower Your</div>
                            <div>Health Journey</div>
                            <div>with Vizzhy App<sub className='primary-color'>•</sub></div>
                        </div>
                        <div className='text-description'>
                            <div>
                                A comprehensive tool for tracking health, food intake, and wellness supported by caregivers and healthcare professionals
                            </div>
                        </div>
                        <div className='d-flex justify-content-center primary-btn contact-us ms-1  py-2  px-2 mt-3 fw-bold learn-btn' style={{ width: "25%" }} onClick={scrollToSection} >
                            <div>Learn More</div>
                            <span class="material-symbols-outlined ms-1">
                                arrow_downward
                            </span>
                        </div>
                    </div>
                    <div className='col-md-4   ' >
                        <div className='align-items-start '>
                            <img className='team-img-width' src={teamicon} alt="Snow" />
                        </div>
                    </div>

                </div>
                {/* <div className='mt-3'>
                <TeamComprehensive  teamSectionRef={teamSectionRef} />
            </div>
            <TeamHowWorks />

            <div>
                <RoleofDashboard />
            </div> */}



                <div>
                    <ProdWhyGoPremium  teamSectionRef={teamSectionRef} />

                </div>
                <div>
                <RoleofDashboard />
            </div>
            </div>



        </>
    );
}

export default Product;


